import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';

import { ModalComponent } from './modal/modal.component';
import { PeopleService } from './shared/services/people.service';
import { Person } from './shared/models/person.model';
import { environment } from '../environments/environment';
import { AppConstants } from './utils/appConstants.class';
import { ConnectionCheck } from './utils/connection-check';

@Component({
    providers: [PeopleService],
    template: '',
    standalone: false
})
export class BasePageComponent {
  public loading: Boolean = false;
  protected location: Location;
  public enableSearch = false;
  public showSearch: Boolean = false;
  public showBreadCrumb: Boolean = false;
  public showPluginHelp: Boolean = false;
  public query = '';
  @ViewChild(ModalComponent, { static: true }) modal: ModalComponent;
  public currentPerson: Person;
  // peopleService: PeopleService;
  public appRoute: string = environment.applicationRoute;
  public inspectionsRoute: string = this.appRoute + '/inspections/';
  public settingsRoute = `${this.appRoute}/settings/`;
  public actionPlansRoute = `${this.appRoute}/actionPlans/`;
  public templatesRoute: string = this.appRoute + '/templates/';
  public isManager = environment.isManager;

  constructor(location: Location) {
    this.location = location;
  }

  initCurrentUser() {
    // this.peopleService.getCurrent().subscribe(data => {
    //    this.currentPerson = data;
    // });
  }

  public goToBack() {
    this.location.back();
  }

  public updateShowSearch(show: boolean = true) {
    this.showSearch = show;
    if (!this.showSearch) {
      this.query = '';
    }
  }

  public showHideBreadcrumb() {
    this.showBreadCrumb = !this.showBreadCrumb;
  }

  public showHidePluginHelp() {
    this.showPluginHelp = !this.showPluginHelp;
  }

  public close() {
    this.modal.close();
  }

  public refresh() {
    window.location.reload();
  }

  public get isConnection() {
    return ConnectionCheck.isConnection;
  }

  public get currentUserId(): string {
    return localStorage.getItem(AppConstants.CURRENT_USER);
  }

  public get offlineInspectionId(): string {
    return localStorage.getItem(`${AppConstants.OFFLINE_INSPECTION}_${this.currentUserId}`);
  }

  public get offlineInspectionName(): string {
    return localStorage.getItem(`${AppConstants.OFFLINE_INSPECTION_NAME}_${this.currentUserId}`);
  }

  public get offlineInspectionAppType(): number {
    return +localStorage.getItem(`${AppConstants.OFFLINE_INSPECTION_APP_TYPE}_${this.currentUserId}`);
  }

  public get currentAppType(): number {
    return +sessionStorage.getItem(AppConstants.CURRENT_APP_TYPE);
  }

  get parentTemplateId(): string {
    return sessionStorage.getItem(AppConstants.PARENT_TEMPLATE_ID);
  }

  set parentTemplateId(value: string) {
    sessionStorage.setItem(AppConstants.PARENT_TEMPLATE_ID, value);
  }
}
